import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "boxTitle" }
const _hoisted_3 = {
  width: "100",
  filter: "createdOn",
  filterType: "date",
  filterFrom: "inizioFrom",
  filterTo: "inizioTo",
  sort: "createdOn"
}
const _hoisted_4 = {
  width: "140",
  filter: "cliente",
  sort: "cliente"
}
const _hoisted_5 = {
  filter: "offers",
  sort: "offers"
}
const _hoisted_6 = {
  width: "80",
  filter: "importoEuro",
  sort: "importoEuro"
}
const _hoisted_7 = {
  width: "80",
  filter: "nazione",
  sort: "nazione"
}
const _hoisted_8 = {
  filter: "figlio",
  sort: "figlio"
}
const _hoisted_9 = {
  width: "100",
  filter: "qualificaFiglio",
  sort: "qualificaFiglio"
}
const _hoisted_10 = { width: "100" }
const _hoisted_11 = {
  width: "100",
  filter: "points",
  sort: "points"
}
const _hoisted_12 = {
  width: "100",
  filter: "guadagnoEuro",
  sort: "guadagnoEuro"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { colspan: "99" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "text-center text-nowrap" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" = ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        localizedKey: "Provvigioni",
        text: "Provvigioni"
      })
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      itemsPerPage: _ctx.filter.perPage,
      items: _ctx.tableResult.data,
      filter: _ctx.filter,
      totalItemsCount: _ctx.tableResult.count,
      onSearch: _ctx.search
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_3, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data creazione",
                text: "Data creazione"
              })
            ]),
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "Cliente",
                text: "Cliente"
              })
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "Carrello",
                text: "Carrello"
              })
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_localized_text, {
                localizedKey: "€ importo",
                text: "€ importo"
              })
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_localized_text, {
                localizedKey: "Nazione",
                text: "Nazione"
              })
            ]),
            _createElementVNode("td", _hoisted_8, [
              _createVNode(_component_localized_text, {
                localizedKey: "Diretto",
                text: "Diretto"
              })
            ]),
            _createElementVNode("td", _hoisted_9, [
              _createVNode(_component_localized_text, {
                localizedKey: "Qualifica figlio",
                text: "Qualifica figlio"
              })
            ]),
            _createElementVNode("td", _hoisted_10, [
              _createVNode(_component_localized_text, {
                localizedKey: "Diff. imprenditoriale",
                text: "Diff. imprenditoriale"
              })
            ]),
            _createElementVNode("td", _hoisted_11, [
              _createVNode(_component_localized_text, {
                localizedKey: "Punti",
                text: "Punti"
              })
            ]),
            _createElementVNode("td", _hoisted_12, [
              _createVNode(_component_localized_text, {
                localizedKey: "€ guadagno",
                text: "€ guadagno"
              })
            ])
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                _createElementVNode("td", _hoisted_14, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.items as OM.ProvvigioniListVm[]), (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn)), 1),
              _createElementVNode("td", null, _toDisplayString(item.cliente), 1),
              _createElementVNode("td", null, [
                (item.offers.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("u", {
                        class: "pointer",
                        onClick: ($event: any) => (_ctx.openOffersModal(item.offers))
                      }, [
                        _createTextVNode(_toDisplayString(item.offers.length) + " ", 1),
                        _createVNode(_component_localized_text, {
                          localizedKey: "elementi",
                          text: "elementi"
                        })
                      ], 8, _hoisted_16),
                      _hoisted_17,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.offers, (offer, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                          _createElementVNode("small", null, "- " + _toDisplayString(offer.name), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, "€ " + _toDisplayString(_ctx.$filters.currency(item.importoEuro)), 1),
              _createElementVNode("td", null, _toDisplayString(item.nazione), 1),
              _createElementVNode("td", null, _toDisplayString(item.figlio), 1),
              _createElementVNode("td", null, _toDisplayString(item.qualificaFiglio), 1),
              _createElementVNode("td", null, _toDisplayString(item.points > 0 ? item.guadagnoEuro / item.points : 0), 1),
              _createElementVNode("td", null, _toDisplayString(item.points), 1),
              _createElementVNode("td", _hoisted_18, [
                _createTextVNode(_toDisplayString(item.points > 0 ? item.guadagnoEuro / item.points : 0) + " €/pt x " + _toDisplayString(item.points) + " pt ", 1),
                _hoisted_19,
                _hoisted_20,
                _hoisted_21,
                _createTextVNode(_toDisplayString(_ctx.$filters.currency(item.guadagnoEuro)) + " € ", 1)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["itemsPerPage", "items", "filter", "totalItemsCount", "onSearch"])
  ]))
}